import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { destructive, destructiveHoverLight, kitTintColor, nameCircles, success } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	accountStatusGray: {
		backgroundColor: nameCircles,
	},
	accountStatusGreen: {
		backgroundColor: success,
	},
	accountStatusOrange: {
		backgroundColor: kitTintColor,
	},
	accountStatusRed: {
		backgroundColor: '#C22639',
	},
	accountStatusYellow: {
		backgroundColor: '#F0E832',
	},
	adminAccountStatus: {
		borderRadius: '50%',
		display: 'inline-block',
		height: 12,
		marginRight: 15,
		width: 12,
	},
	// Cancelled accounts use `destructive` to match the "Cancelled" pills elsewhere on the page.
	accountStatusCancelled: {
		backgroundColor: destructive,
	},
	adminAccountStatusCancelled: {
		height: 18,
		width: 18,
		// The ring extends left of the dot; the parent container clips overflow,
		// so nudge right to keep the ring from being cut off on the left.
		marginLeft: THEME.spacing.xs,
		boxShadow: `0 0 0 3px ${destructiveHoverLight}`,
	},
});
